import { jsx as t } from "react/jsx-runtime";
import { Portal as p } from "../Portal/Portal.js";
const m = ({ inPortal: o = !1, children: r }) => o ? /* @__PURE__ */ t(p, { children: r }) : r;
export {
  m as PopoverWrapper
};
//# sourceMappingURL=PopoverWrapper.js.map
